import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MovieCard from '../components/MovieCard';
import { moviesAPI } from '../api';
import { useSettings } from '../contexts/SettingsContext';

const Upcoming = () => {
  const { settings } = useSettings();
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMovies();
  }, []);

  // Update title on mount
  useEffect(() => {
    document.title = `Yakında Vizyona Girecek Filmler - ${settings.site_name || 'Cinefora'}`;
  }, [settings.site_name]);

  // Calculate days until release date for sorting
  const getDaysUntilRelease = (releaseDate) => {
    if (!releaseDate) return 999999; // Put movies without date at the end
    
    try {
      const today = new Date();
      let release;
      
      // Handle Turkish date format: "7 Kasım 2025"
      if (releaseDate.includes('Kasım') || releaseDate.includes('Ekim') || releaseDate.includes('Eylül') || releaseDate.includes('Ocak') || releaseDate.includes('Şubat') || releaseDate.includes('Mart') || releaseDate.includes('Nisan') || releaseDate.includes('Mayıs') || releaseDate.includes('Haziran') || releaseDate.includes('Temmuz') || releaseDate.includes('Ağustos') || releaseDate.includes('Aralık')) {
        // Convert Turkish months to English
        const turkishToEnglish = {
          'Ocak': 'January', 'Şubat': 'February', 'Mart': 'March',
          'Nisan': 'April', 'Mayıs': 'May', 'Haziran': 'June',
          'Temmuz': 'July', 'Ağustos': 'August', 'Eylül': 'September',
          'Ekim': 'October', 'Kasım': 'November', 'Aralık': 'December'
        };
        
        let englishDate = releaseDate;
        Object.keys(turkishToEnglish).forEach(turkishMonth => {
          englishDate = englishDate.replace(turkishMonth, turkishToEnglish[turkishMonth]);
        });
        
        release = new Date(englishDate);
      } else {
        release = new Date(releaseDate);
      }
      
      // Check if date is valid
      if (isNaN(release.getTime())) {
        return 999999; // Invalid dates go to the end
      }
      
      // Remove time part for accurate day calculation
      today.setHours(0, 0, 0, 0);
      release.setHours(0, 0, 0, 0);
      
      const diffTime = release - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      return diffDays;
    } catch (error) {
      console.error('Date calculation error:', error);
      return 999999; // Error cases go to the end
    }
  };

  // Sort movies by release date (closest first)
  const sortMoviesByReleaseDate = (moviesList) => {
    return [...moviesList].sort((a, b) => {
      const daysA = getDaysUntilRelease(a.release_date);
      const daysB = getDaysUntilRelease(b.release_date);
      return daysA - daysB; // Ascending order (closest dates first)
    });
  };

  const loadMovies = async () => {
    try {
      const response = await moviesAPI.getAll({ status: 'upcoming' });
      const sortedMovies = sortMoviesByReleaseDate(response.data);
      setMovies(sortedMovies);
    } catch (error) {
      console.error('Error loading movies:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Helmet>
        <title>Yakında Vizyona Girecek Filmler - {settings.site_name || 'Cinefora'}</title>
        <meta name="description" content="Cinefora'da yakında vizyona girecek filmleri keşfedin. Yeni çıkacak filmler ve fragmanlar." />
        <meta name="keywords" content="yakında, yeni filmler, vizyon takvimi, cinefora" />
      </Helmet>
      <Header />
      
      <div className="container mx-auto px-6 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Yakında Vizyona Girecek Filmler</h1>
        
        {loading ? (
          <p className="text-white text-center">Yükleniyor...</p>
        ) : movies.length === 0 ? (
          <p className="text-gray-400 text-center">Henüz yakında vizyona girecek film bulunmamaktadır.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {movies.map((movie) => (
              <MovieCard key={movie._id} movie={movie} />
            ))}
          </div>
        )}
      </div>
      
      <Footer />
    </div>
  );
};

export default Upcoming;
